import { render, staticRenderFns } from "./Points.template.vue?vue&type=template&id=1d020f70&scoped=true&"
var script = {}
import style0 from "./Points.template.vue?vue&type=style&index=0&id=1d020f70&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d020f70",
  null
  
)

export default component.exports